
const ConversationState = {
  in_queue: 'in_queue',
  being_helped: 'being_helped',
  ongoing: 'ongoing',
  resolved: 'resolved'
}

export default ConversationState;
